import React, { useEffect } from 'react';
import {PreviewFab} from "./PreviewFab";

/**
 * Full‑screen modal preview for OfficialLayout on **all** breakpoints.
 *
 * - Opens via a floating FAB button (visible on all sizes)
 * - Closes on: Close button, overlay click, or Escape key
 * - Locks background scroll while open
 * - Keeps A4 width (210mm) inside a scrollable body for fidelity
 */
export function ModalOfficialPreview({
                                         showPreview,
                                         setShowPreview,
                                         getValues,
                                         optionsSpecialties,
                                         selectedYear,
                                         OfficialLayout,
                                         title = 'Офіційне прев’ю',
                                     }) {
    // Lock background scroll when modal is open
    useEffect(() => {
        if (!showPreview) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, [showPreview]);

    // Close on Escape
    useEffect(() => {
        if (!showPreview) return;
        const onKey = (e) => { if (e.key === 'Escape') setShowPreview(false); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [showPreview, setShowPreview]);

    return (
        <>
            <style>{`
        .preview-fab { position: fixed; right: 16px; bottom: 16px; z-index: 60; border-radius: 9999px; padding: 10px 14px; background:#111827; color:#fff; box-shadow: 0 8px 24px rgba(0,0,0,.18); display:flex; align-items:center; gap:8px; }
        .preview-fab:hover { opacity: .9; }

        .preview-overlay { position: fixed; inset: 0; z-index: 90; background: rgba(0,0,0,.45); }
        .preview-modal   { position: fixed; inset: 0; z-index: 100; background:#fff; display:flex; flex-direction:column; }
        .preview-header  { display:flex; align-items:center; justify-content:space-between; padding:12px 16px; border-bottom:1px solid #e5e7eb; }
        .preview-body    { flex:1; overflow:auto; padding: 8px; }
        .close-btn { display:inline-flex; align-items:center; gap:8px; border:1px solid #e5e7eb; padding:8px 12px; border-radius:10px; background:#fff; }
        .close-btn:hover { background:#f9fafb; }

        /* Keep page width stable for print fidelity */
        .a4 { width: 210mm; min-width: 210mm; margin: 0 auto; }

        @media (max-width: 480px) {
          .close-btn { padding: 8px 10px; }
        }
      `}</style>
            {!showPreview && <PreviewFab onClick={() => setShowPreview(true)} />}

            {showPreview && (
                <div>
                    <div className="preview-overlay" onClick={() => setShowPreview(false)} />
                    <div className="preview-modal" role="dialog" aria-modal="true" aria-label={title}>
                        <div className="preview-header">
                            <div style={{ fontWeight: 600 }}>{title}</div>
                            <button type="button" className="close-btn" onClick={() => setShowPreview(false)} aria-label="Закрити прев’ю">
                                Закрити
                            </button>
                        </div>
                        <div className="preview-body">
                            <div className="a4">
                                <OfficialLayout values={getValues()} specialties={optionsSpecialties} selectedYear={selectedYear} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
